import { route } from 'preact-router';
import { prepareIFrame, getHtmlElement, sendPostMessage } from '../../utils/browserUtils';

import postMessageTypes from '../../constants/messageTypes';
import { statusURLPrefix } from '../../constants/urls';
import { onWindowCloseSendMessagePromise, setupKiteHoldingAuthorizationForwarding } from './windowListeners';
import errorMap from '../../utils/errorUtils';

export const DEFAULT_SELECTOR = 'body';

function getRandomInt() {
  // number between 0 and 999999
  return Math.floor(Math.random() * 999999);
}

export class PrimaryNewTab {
  static windowName = `sc-gw-${getRandomInt()}`;

  constructor(url) {
    this.windowInstance = window.open(url, PrimaryNewTab.windowName);

    if (this.windowInstance.toString() !== '[object Window]') {
      throw errorMap.FAILED_TO_OPEN_WINDOW;
    }

    this.show();
    this.windowType = 'newtab';

    const onWindowClosePromiseObj = onWindowCloseSendMessagePromise({
      windowInstance: this.windowInstance,
    });
    this.cancelWindowClosePromise = onWindowClosePromiseObj.cancel;
  }

  isOpen() {
    return ((this.windowInstance !== undefined) &&
      !(this.windowInstance.closed));
  }

  // eslint-disable-next-line class-methods-use-this
  show() {
    if (this.isOpen()) {
      this.windowInstance.focus();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  hide() {
    window.focus();
  }

  changeURL(url) {
    this.windowInstance.location.replace(url);
    this.show();
  }

  close() {
    this.cancelWindowClosePromise();

    this.windowInstance.close();
    this.hide();
    this.windowInstance = undefined;
    this.windowType = undefined;
  }
}

export class PrimaryIframe {
  constructor(url, silentIframe = false) {
    this.referenceElement = getHtmlElement(DEFAULT_SELECTOR);
    this.windowInstance = prepareIFrame(url);
    if (!silentIframe) this.show();
    this.referenceElement.appendChild(this.windowInstance);
    this.windowType = 'iframe';
    setupKiteHoldingAuthorizationForwarding(this.windowInstance.contentWindow);
  }

  isOpen() {
    return (this.windowInstance !== undefined);
  }

  // eslint-disable-next-line class-methods-use-this
  show() {
    // Ask parent window to show secondary iframe (which contains this primary iframe)
    sendPostMessage({ messageType: postMessageTypes.SHOW_FRAME });
  }

  // eslint-disable-next-line class-methods-use-this
  hide() {
    // Ask parent window to hide secondary iframe (which contains this primary iframe)
    sendPostMessage({ messageType: postMessageTypes.HIDE_FRAME });
  }

  changeURL(url) {
    this.show();
    this.windowInstance.src = url;
  }

  close(shouldHide = true) {
    shouldHide && this.hide();
    this.referenceElement.removeChild(this.windowInstance);
    this.windowInstance = undefined;
    this.windowType = undefined;
  }
}

export class SecondaryIframe {
  constructor(status) {
    this.windowInstance = window;
    this.windowType = 'iframe';
    this.show();
    this.changeURL(status);
  }

  isOpen() {
    return (this.windowInstance !== undefined);
  }

  // eslint-disable-next-line class-methods-use-this
  show() {
    // Ask parent window to show self
    sendPostMessage({ messageType: postMessageTypes.SHOW_FRAME });
  }

  // eslint-disable-next-line class-methods-use-this
  hide() {
    // Move back to empty state
    route(statusURLPrefix, true);
    // Ask parent window to hide self
    sendPostMessage({ messageType: postMessageTypes.HIDE_FRAME });
  }
  // eslint-disable-next-line class-methods-use-this

  changeURL(status) {
    this.show();
    route(statusURLPrefix + status, true);
  }

  close(shouldHide = true) {
    shouldHide && this.hide();
    this.windowInstance = undefined;
    this.windowType = undefined;
  }
}

/* eslint-disable quote-props */
export const primaryClassMap = {
  'iframe': PrimaryIframe,
  'newtab': PrimaryNewTab,
};
/* eslint-enable quote-props */



// WEBPACK FOOTER //
// ./logic/WindowManager/windowClasses.js